<template>
	<div>
		<!-- dialog body -->
		<v-dialog v-model="addEditTagDialog" persistent max-width="550px">
			<v-card>
				<v-card-title class="justify-center">
					<h3> {{ !is_editing ? 'Add' : 'Edit' }} Tag </h3>
					<v-btn icon absolute top right color="dark" @click="closeTagDialog(false)">
						<b>x</b>
					</v-btn>
				</v-card-title>

				<v-card-text>
					<v-form
						ref="form"
						v-model="submitForm"
						@submit.prevent
					>
						<v-container fluid>
							<v-row justify="center">
								<!-- title field -->
								<v-col cols="12" md="11">
									<v-text-field
										outlined
										dense
										label="Title"
										class="rounded-input"
										:rules="[rules.required]"
										v-model="addEditTag.name"
									>
									</v-text-field>
								</v-col>
							</v-row>

							<v-row justify="center">
								<!-- color picker -->
								<v-col cols="12" md="11" align-self="center">
									<div style="display: flex; justify-content: center; align-items: center;">
										<label for="color-picker">
											<h3>Pick a color</h3>
										</label>
									</div>
									
									<input type="color" name="color-picker" v-model="addEditTag.color" style="border-radius: 50%; width: 100px; height: 50px; padding: 0.4rem">
								</v-col>
							</v-row>

							<v-row justify="center">
								<v-col>
									<!-- submit btn -->
									<v-btn
										color="primary"
										type="submit"
										v-model="submitForm"
										:disabled="isLoading || !submitForm"
										@click="saveTag()"
									>
										{{ is_editing ? 'Submit' : 'Add' }} Tag
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- snackbar -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
			{{ snackbar.message }}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
					Close
				</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
import api from "@api/index"
import { mapActions, mapGetters } from "vuex"
import endpoints from "@api/repository"
// import Helper from "@utils/misc"
import moment from "moment"

export default {
	name: 'AddEditTags',

	props: {
		"visible": {
			type: Boolean,
			default: false
		},
		"is_editing": {
			type: Boolean,
			default: false
		},
		"tagData": {
			type: Object,
			default: () => {}
		},
		"feature":{
			type: String,
			default: null
		},
		"endpointURL":{
			type: String,
			default: endpoints.taskTags
		}
	},

	components: {},

	data() {
		return {
			moment: moment,
			snackbar: {
				visible: false,
				message: "",
				color: "dark",
			},
			rules: {
				required: (value) => !!value || "Required",
			},

			submitForm: false,
			addEditTagDialog: false,

			addEditTag: {
				name: null,
				color: '#000000',
				institution: null
			}
		}
	},

	computed: {
		...mapGetters([
			"currentUser",
			"accessToken",
			"isLoading",
			"currentInstitution",
		]),

		apiEssentials() {
			return {
				accessToken: this.accessToken,
				setLoading: this.setLoading,
				handleErrorsFunction: this.handleApiErrors,
			};
		},
	},

	methods: {
		...mapActions(["setLoading"]),

		// handle api errors
		async handleApiErrors(err) {
			this.setLoading(false);
			console.log(err);
			if (err.response) {
				// for repeated tag name backend error
				if (err.response.status == 400) {
					this.snackbar.message = "Tag name is already in use. Please choose a different one";
					this.snackbar.color = "error";
					this.snackbar.visible = true;
				}
			} else {
				this.snackbar.message = "Unable to process request";
				this.snackbar.color = "error";
				this.snackbar.visible = true;
			}
		},

		validate() {
			if(!this.addEditTag.name) {
				this.snackbar.message = "Tag name cannot be blank!"
				this.snackbar.visible = true
				this.snackbar.color = "success"

				return false
			}

			if(!this.addEditTag.color) {
				this.snackbar.message = "Tag color cannot be blank!"
				this.snackbar.visible = true
				this.snackbar.color = "success"

				return false
			}

			return true
		},

		async saveTag() {

			var url = this.endpointURL;
			// Choosing right endpoint depending upon from where tags are being called.
			// this.feature == "tasks" ?  url = endpoints.taskTags : url = endpoints.feeParticularTags
			console.log(this.feature, url, this.endpointURL)
			url
			if(this.validate()) {
				// if editing a tag detail
				if(this.is_editing) {
					url += `${this.addEditTag.id}/`
					var response = await api.call(this.apiEssentials, url, api.Methods.PUT, this.addEditTag)
				}
				// creating new tag
				else {
					response = await api.call(this.apiEssentials, url, api.Methods.POST, this.addEditTag)
				}

				if(response) {
					this.snackbar.message = "Tag saved successfully!"
					this.snackbar.visible = true
					this.snackbar.color = "success"

					this.closeTagDialog(false)
					// tell the parent to fetch tags again
					this.$emit('fetchFreshTags', true)
				}
			}
		},

		closeTagDialog(status) {
			if(!status) {
				this.addEditTagDialog = false
				this.$refs.form.reset()
				this.addEditTag = {
					name: null,
					color: '#000000',
					institution: this.currentInstitution.id
				},
				this.$emit('closeTagDialog', status)
			}
		}
	},

	watch: {
		visible: {
			async handler() {
				this.addEditTagDialog = this.visible
			}
		},

		tagData: {
			async handler() {
				if(this.tagData) {
					this.addEditTag = this.tagData
				}
			}
		}
	},

	created() {
		this.addEditTag.institution = this.currentInstitution.id
	}
}
</script>

<style>

</style>